import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-already-set-up": "",
  class: "m-0 rounded-md bg-gray-100 px-3 py-2 text-[13px] text-gray-600"
}

import { computed, watch } from 'vue'

import SelectionCard from '@/components/neue/wizard/SelectionCard.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { sectionCopy, stepCoveredByExisting, stepForKey, STORE_STEP_KEYS } from '@/config/agentWizardSteps'


export default {
  __name: 'AgentChooseSection',
  props: { stepKey: { type: String, required: true } },
  setup(__props) {

const SUBTITLES = {
  winback: 'Text customers who have stopped ordering.',
  reviews: 'Ask happy regulars for a Google review.',
  carts: 'Text people who left meals in their cart.',
  upsell: 'Offer add-ons to customers who already paid.'
}

const props = __props

const wizard = injectWizard()
const section = computed(() => wizard.data[props.stepKey])

const noStore = computed(() => STORE_STEP_KEYS.includes(props.stepKey) && wizard.stores.value.length === 0)
const covered = computed(() => stepCoveredByExisting(props.stepKey, wizard.existing.value, wizard.stores.value))
const note = computed(() => {
  if (noStore.value) return 'You need a store first. Add one under'
  if (!covered.value) return ''
  return wizard.ctx.storeCount > 1 ? 'Already set up for every store' : `Already set up for ${wizard.ctx.storeName}`
})

watch(
  () => covered.value || noStore.value,
  skipped => {
    if (skipped) section.value.enabled = false
  },
  { immediate: true }
)

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(WizardSection, _mergeProps(_unref(sectionCopy)('agent.choose', _unref(wizard).data, _unref(wizard).ctx), { plain: "" }), {
    default: _withCtx(() => [
      (note.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
            _createTextVNode(_toDisplayString(note.value) + " ", 1),
            (noStore.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/store",
                  class: "font-medium underline"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("Stores", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(SelectionCard, {
              mode: "radio",
              name: `choose-${__props.stepKey}`,
              selected: section.value.enabled,
              title: `Yes, set up ${_unref(stepForKey)(__props.stepKey).label}`,
              subtitle: SUBTITLES[__props.stepKey],
              onSelect: _cache[0] || (_cache[0] = $event => (section.value.enabled = true))
            }, null, 8, ["name", "selected", "title", "subtitle"]),
            _createVNode(SelectionCard, {
              mode: "radio",
              name: `choose-${__props.stepKey}`,
              selected: !section.value.enabled,
              title: "Skip for now",
              subtitle: "Nothing is created. You can add it any time from AI Agents.",
              onSelect: _cache[1] || (_cache[1] = $event => (section.value.enabled = false))
            }, null, 8, ["name", "selected"])
          ], 64))
    ]),
    _: 1
  }, 16))
}
}

}